export const githubSearchApiEndpoint = `https://api.github.com/graphql`;

